import { render, staticRenderFns } from "./ruleConfig.vue?vue&type=template&id=0c6fcd32&"
import script from "./ruleConfig.vue?vue&type=script&lang=js&"
export * from "./ruleConfig.vue?vue&type=script&lang=js&"
import style0 from "./ruleConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6fcd32')) {
      api.createRecord('0c6fcd32', component.options)
    } else {
      api.reload('0c6fcd32', component.options)
    }
    module.hot.accept("./ruleConfig.vue?vue&type=template&id=0c6fcd32&", function () {
      api.rerender('0c6fcd32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Performance/tabPane/ruleConfig.vue"
export default component.exports